module.exports = __webpack_public_path__ + "fonts/Manrope-700-cyrillic20_efc8e8d.woff2";